import { render, staticRenderFns } from "./UploadInvoice.vue?vue&type=template&id=3d2a2116&"
import script from "./UploadInvoice.vue?vue&type=script&lang=ts&"
export * from "./UploadInvoice.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VWindow } from 'vuetify/lib/components/VWindow';
import { VWindowItem } from 'vuetify/lib/components/VWindow';
installComponents(component, {VCol,VContainer,VRow,VWindow,VWindowItem})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3d2a2116')) {
      api.createRecord('3d2a2116', component.options)
    } else {
      api.reload('3d2a2116', component.options)
    }
    module.hot.accept("./UploadInvoice.vue?vue&type=template&id=3d2a2116&", function () {
      api.rerender('3d2a2116', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/invoicing/views/UploadInvoice.vue"
export default component.exports